import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'ecat-mobile-search',
    templateUrl: './ecat-mobile-search.component.html',
    styleUrls: ['./ecat-mobile-search.component.less']
})
export class EcatMobileSearchComponent {
    isVinSearchVisible = true;
    isVinPartsSearchVisible = false;
    isProductVinPartsSearchVisible = false;
    selectedTabIndex = 1;
    showDetail = false;
    selectedItem: any;
    carModalVisible = true;
    productVisible = false;
    constructor(
        private router: Router,
    ) { }
    ngOnInit(): void {
        const seachByProduct = history.state.seachByProduct;
        if (seachByProduct) {
            this.selectedTabIndex = 2;
            this.carModalVisible = false;
            this.productVisible = true;
        }
    }

    onTabChange(index: number): void {
        this.selectedTabIndex = index;
        if (index === 0) {
            this.router.navigate(['gb/cn/parts']);
        }
        if (index === 1) {
            this.carModalVisible = true;
            this.productVisible = false;
        }
        if (index === 2) {
            this.carModalVisible = false;
            this.productVisible = true;
        }
    }

    receiveData(data: any) {
        this.isVinSearchVisible = false;
        this.isVinPartsSearchVisible = true;
    }

    receivePartsData(data: any) {
        this.isVinSearchVisible = true;
        this.isVinPartsSearchVisible = false;
    }
    onViewDetail(item: any) {
        this.selectedItem = item;
        this.showDetail = true;
    }

    onBack() {
        this.showDetail = false;
    }
}
